import { B as l } from "./chunk-BaseElement-CJM6sCUz.js";
import { W as s } from "./chunk-WithShopifyCart-BrHwaVIT.js";
import { n as u } from "./chunk-property---aaewZr.js";
var c = Object.defineProperty, p = (o, e, r, h) => {
  for (var t = void 0, a = o.length - 1, i; a >= 0; a--)
    (i = o[a]) && (t = i(e, r, t) || t);
  return t && c(e, r, t), t;
};
class n extends s(l) {
  constructor() {
    super(), this.countTotal = null, this.countLabel = null, this.empty = !1, this.countTotal = this.querySelector("[data-cart-count]"), this.countLabel = this.querySelector("[data-cart-count-label]");
  }
  updated(e) {
    super.updated(e), this.countTotal && (this.countTotal.textContent = this.cart.item_count.toString()), this.empty = this.cart.item_count === 0;
  }
}
p([
  u({ type: Boolean, attribute: "data-empty", reflect: !0 })
], n.prototype, "empty");
window.customElements.define("cart-total", n);
export {
  n as CartTotal
};
